import { useEffect } from 'react';
import { refreshPushRegistration } from './usePushNotifications';

/** Mínimo entre dos avisos al backend: volver a la app varias veces seguidas no lo satura. */
export const HEARTBEAT_MIN_INTERVAL_MS = 30 * 60 * 1000;

/**
 * Le avisa al backend que la app se abrió (al entrar y cada vez que vuelve a primer plano, como mucho cada 30 minutos),
 * para que psima vea la "última vez activa" del celular. Se monta una sola vez en `PwaShell`.
 */
export function usePushHeartbeat(): void {
  useEffect(() => {
    let last = 0;
    const beat = () => {
      const now = Date.now();
      if (now - last < HEARTBEAT_MIN_INTERVAL_MS) return;
      last = now;
      void refreshPushRegistration();
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') beat();
    };

    beat();
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);
}
